// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b38631b7","455":"510ed2b1","977":"3a848a25"}[chunkId] + ".chunk.js";
};